import styled from 'styled-components/macro';
import px2vw from '../../../utils/px2vw';

export const WhereQberaaTitle = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => { 
        return props.theme.mobCommonTitleFontSize?props.theme.mobCommonTitleFontSize:px2vw(20)
    }};  
    letter-spacing: ${props => props.theme.subtitleLetterSpacing};
    font-weight: 700;
    line-height: ${px2vw(30)};  
    padding-bottom: ${px2vw(14)};
    @media only screen and (max-width: 600px) {
        padding-bottom: ${px2vw(150)};
        padding-top: ${px2vw(200)};
        line-height: ${px2vw(100)};  
    }
`;
export const WhereRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    background-color: #0A2540; 
    color : #FFFFFF;
    /* padding-left:  ${props => props.theme.paddingLeft};
    padding-right: ${props => props.theme.paddingRight}; */
    padding-top : ${px2vw(80)};
    padding-bottom : ${px2vw(96)};
    @media only screen and (max-width: 425px) {     
        flex-direction: column;
        align-items: center;      
        padding-left: 5%;
        padding-right: 5%;

    }
`;

export const WhereQberaaContent = styled.div`
    font-family: ${props => props.theme.fontFamily};
    font-size:  ${props => props.theme.pFontSize};
    line-height:  ${props => props.theme.pLineHeight};
    font-weight: 400;
    letter-spacing: 0px;
    padding-bottom: ${px2vw(40)};
`;

export const WhereQberaaRedBox = styled.div`
    height: ${px2vw(12)};
    width: ${px2vw(81)};
    border-radius: 0px;
    background: #E32C5E;    
    @media only screen and (max-width: 425px) {
        height: ${px2vw(10)};
        width: ${px2vw(350)};
        padding-bottom: ${px2vw(40)};
    }
`;

export const WhereQberaavideo = styled.video`
    height: ${px2vw(312)};
    width: ${px2vw(480)};
    border-radius: ${px2vw(20)};
    padding-left: ${px2vw(81)};    
    @media only screen and (max-width: 425px) {     
        height: auto;
        width: ${px2vw(1300)};
        padding-left: 0;           
        padding-top:  ${px2vw(200)};  
        padding-bottom:  ${px2vw(150)};             
    }
`;


